import React from "react";

import { HiCheckCircle, HiXCircle } from "react-icons/hi";
import { SettingsReadiness } from "./settingsReadiness";

const scrollToSection = (event: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
  event.preventDefault();
  document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const SettingsReadinessPanel = ({ readiness }: { readiness: SettingsReadiness }) => {
  const { items, readyCount, totalCount } = readiness;
  const allReady = readyCount === totalCount;

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-700 dark:bg-slate-800">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-100">Gotowość do wdrożenia</h2>
        <span
          className={`rounded-full px-3 py-1 text-sm font-semibold ${
            allReady
              ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-300"
              : "bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-300"
          }`}
        >
          {readyCount}/{totalCount} gotowe
        </span>
      </div>
      <ul className="grid grid-cols-1 gap-x-6 gap-y-1 md:grid-cols-2">
        {items.map((item) => (
          <li key={item.key}>
            <a
              href={`#${item.sectionId}`}
              onClick={(event) => scrollToSection(event, item.sectionId)}
              className="flex items-center gap-2 rounded px-1 py-0.5 text-sm text-slate-700 hover:bg-slate-100 hover:underline dark:text-slate-200 dark:hover:bg-slate-700"
            >
              {item.ready ? (
                <HiCheckCircle className="shrink-0 text-emerald-500" size={20} aria-label="gotowe" />
              ) : (
                <HiXCircle className="shrink-0 text-rose-500" size={20} aria-label="brak" />
              )}
              <span>{item.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};
